module.exports = __webpack_public_path__ + "img/Miscellaneous.ae00bcf2.jpg";